import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { airloomApi } from "@/store/airloom-generated-rtk";
import BusinessAndLocationReducer from "@/store/slices/locationIdSlice";
import machineUsageReducer from "@/store/slices/machineUsageSlice";

export const store = configureStore({
  reducer: {
    [airloomApi.reducerPath]: airloomApi.reducer,
    businessAndLocation: BusinessAndLocationReducer,
    machineUsage: machineUsageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(airloomApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
